import { status, statusERP } from './ave/ave-types';
import { boolean, number } from './common/common-types';
import { hyperlink, image, percentage, date, datetime } from './excel/excel-types';

export const types = {
  number,
  boolean,
  excel: {
    hyperlink,
    percentage,
    image,
    date,
    datetime,
  },
  ave: {
    status,
    statusERP,
  }
};
